import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { LogoutModal, useClient } from 'shared-ui';

import { getSettings } from 'api/general/general';
import { QueryKeyEnum } from 'core/global.enum';
import { useAuth } from 'hooks/useAuth/useAuth';
import { LogoutModalContext } from '../logoutModalContext/LogoutModalContext';
import { useQuery } from 'hooks/useQuery/useQuery';
import { AppName } from 'ui/appName/AppName';

import { LogoutModalContextControllerProps } from './LogoutModalContextController.types';

export const LogoutModalContextController = ({ children }: LogoutModalContextControllerProps) => {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const { isAuthenticated, clearClientData, logout } = useAuth();
  const { isSessionExpired, hasPermissionChanged } = useClient();

  useEffect(() => {
    if (isSessionExpired) {
      setIsLogoutModalOpen(true);
      logout();
    }
  }, [isSessionExpired]);

  const { data: settings } = useQuery([QueryKeyEnum.SETTINGS], getSettings, {
    enabled: isAuthenticated,
    onSuccess: () => {
      start();
    },
  });

  const { start, pause } = useIdleTimer({
    onIdle: () => {
      logout();
      setIsLogoutModalOpen(true);

      pause();
    },
    timeout: settings?.logoutTime ? settings.logoutTime * 1000 : undefined,
    startManually: true,
    crossTab: true,
    syncTimers: 1000,
  });

  const handleModalActionClick = () => {
    pause();
    setIsLogoutModalOpen(false);
    clearClientData();
    window.location.reload();
  };

  return (
    <LogoutModalContext.Provider value={{ setIsLogoutModalOpen, isLogoutModalOpen }}>
      {children}
      <LogoutModal
        hasPermissionChanged={hasPermissionChanged}
        appName={<AppName />}
        isOpen={isLogoutModalOpen}
        handleModalActionClick={handleModalActionClick}
      />
    </LogoutModalContext.Provider>
  );
};
